<template>
  <div class="add-project-npa">
    <v-btn v-if="solveNeeded" class="btn-add-category" :aria-label="$t('Добавить проект НПА')" @click.native.stop="npaProjectDialog = true">
      <span class="pro-icon-add" aria-hidden="true"></span>{{ $t("Добавить проект НПА") }}
    </v-btn>
    <v-dialog v-model="npaProjectDialog" max-width="560">
      <v-card class="modal modal-project-npa-law">
        <div class="modal-head">
          {{ $t('Форма добавления проекта НПА к Закону') }}
          <v-btn color="modal-close" :aria-label="$t('Закрыть')" @click.native="npaProjectDialog = false">
            <span class="pro-icon-close1" aria-hidden="true"></span>
          </v-btn>
        </div>
        <div
          class="modal-body"
        >
          <div class="form-group">
            <h5>{{ $t( "Добавить проект НПА из базы проектов НПА") }}</h5>
            <v-autocomplete
              v-if="!formAdding"
              v-model="project.npa"
              :loading="loading"
              :items="items"
              :search-input.sync="search"
              cache-items
              item-text="transName"
              item-value="id"
              required
              outlined
              dense
              clearable
              :placeholder="$t('Введите название для поиска')"
            />
          </div>
          <div class="form-group">
            <v-select
              v-if="!formAdding"
              v-model="project.stage"
              :items="stages"
              item-text="transName"
              item-value="id"
              outlined
              dense
              :placeholder="$t('Стадия')"
            />
          </div>
          <div class="form-group">
            <v-textarea
              v-model="project.note"
              outlined
              :placeholder="$t('Стадия')"
            />
          </div>
          <div class="adding-db-npa">
            <div class="form-group">
              <a
                href="#"
                @click.prevent="formAdding = true"
                :class="{hide: formAdding === true }"
              >
                {{ $t("Нового проекта НПА ещё нет в базе данных") }}
              </a>
            </div>
            <div v-if="formAdding" class="form-adding-db-npa">
              <div class="form-head">
                <div class="form-group">
                  <label>{{ $t( "Если нового проекта НПА ещё нет в базе данных, временно введите его название на двух языках. Позже его необходимо добавить в базу проектов НПА и затем выбрать к данному закону") }}</label>
                </div>
              </div>
              <div class="form-body">
                <div class="form-group">
                  <label>
                    {{ $t("Наименование на государственном языке") }} <span class="asterix">*</span>
                  </label>
                  <v-text-field
                    v-model="project.npaNameKg"
                    outlined
                    dense
                    clearable
                  />
                </div>
                <div class="form-group">
                  <label>
                    {{ $t("Наименование на официальном языке") }} <span class="asterix">*</span>
                  </label>
                  <v-text-field
                    v-model="project.npaName"
                    outlined
                    dense
                    clearable
                  />
                </div>
              </div>
            </div>
            <div class="form-group form-action">
              <button
                class="btn btn-default blue"
                @click.prevent="addNpaProject()"
              >
                {{ $t("Добавить") }}
              </button>
              <button
                class="btn btn-default white"
                @click.prevent="npaProjectDialog = false; formAdding = false"
              >
                {{ $t("Отмена") }}
              </button>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

  import {mapMutations} from 'vuex'
  import LAW from '@/model/law'

  export default {
    props: {
      solveNeeded: Boolean,
    },
    mounted() {
      this.fetchData()
    },
    data: () => ({
      npaData: [],
      bool: true,
      project: {},
      npaProjectDialog: false,
      formAdding: false,
      stages: [],
      npas: [],
      items: [],
      loading: false,
      search: null,
    }),
    watch: {
      search (val) {
        val && val !== this.npaId && this.querySelections(val)
      },
    },
    methods: {
      ...mapMutations(['setLoading']),
      fetchData() {
        this.setLoading(true)
        LAW.getProjectFormData(this.$route.params.id).then((response) => {
          this.stages = response.data.stages
          this.npas = response.data.npas
        }).catch((error) => {
          console.log(error)
        })
        this.setLoading(false)
      },
      addNpaProject() {
        let validate = false
        if (this.formAdding === true) {
          this.bool = false
          if (this.project.hasOwnProperty('npaName') && this.project.hasOwnProperty('npaNameKg')) {
            validate = true
          }
        } else {
          this.bool = true
          if (this.project.hasOwnProperty('npa') && this.project.hasOwnProperty('stage')) {
            validate = true
          }
        }
        if (!validate) {
          this.$noty.error(this.$i18n.t('Внимание! Ошибки при отправки формы. Пожалуйста, проверьте правильность заполнения формы'), {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
          return
        }
        LAW.createLawProject(this.$route.params.id, this.bool, this.project).then((response) => {
          this.project = {}
          if (response.status === 201) {
            this.npaProjectDialog = false
            this.formAdding = false
            this.$parent.fetchData(false)
          }
        })
      },
      querySelections (v) {
        this.loading = true
        setTimeout(() => {
          this.items = this.npas
          this.loading = false
        }, 500)
      },
    }
  }
</script>
